// extracted by mini-css-extract-plugin
export default {"textHolder":"WelecomeComponent_textHolder__ldamE","textHolderCol":"WelecomeComponent_textHolderCol__T-haA"};